export class DashBoardSurface {
    static jsonMap = {
        idEspece: 'idEspece',
        codeEspece: 'codeEspece',
        surface: 'surface'
    };

    idEspece: number;
    codeEspece: string;
    surface: number;
}
